<template>
    <div>
        <div class="head">
            <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="bPlanList"
                    :header-cell-style="{ background: 'rgb(250,250,250)' }"
                    style="width: 100%">
                <el-table-column label="任务名称" align="center" prop="bname"/>
                <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                        <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
                        <span style="margin: 0 5px;color: #e8e8e8">|</span>
                        <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 15px">
                <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
            </div>
        </div>

        <!-- 添加或修改包保责任人任务管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item label="任务名称" prop="bName">
                    <el-input v-model="form.bname" placeholder="请输入任务名称"/>
                </el-form-item>
                <el-form-item label="任务类型" prop="bName">
                    <el-input v-model="form.workType" placeholder="请输入任务类型"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import { listBPlan, getBPlan, delBPlan, addBPlan, updateBPlan } from "@/api/doublePrevention/bPlan";

    export default {
        name: 'BPlan',
        data() {
            return {
                // searchContent: '',
                bPlanList: [],
                total: 0,
                curPage: 1,
                pageSize: 10,
                open: false,
                form: {},
                rules: {},
                title: null
            }
        },
        created() {
            this.getBPlanList();
        },
        methods: {
            getBPlanList() {
                listBPlan({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
                    this.bPlanList = res.body.data
                    this.total = res.body.cum
                })
            },
            pageChange(val) {
                this.curPage = val;
                this.getBPlanList();
            },
            addBtn() {
                this.reset()
                this.open = true
                this.title = '添加包保责任信息'
            },
            editBtn(row) {
                this.reset()
                const id = row.id
                getBPlan(id).then(response => {
                    this.form = response.body.data
                    this.open = true
                    this.title = '修改包保责任信息'
                })
            },
            deleteBtn(row) {
                delBPlan(row.id).then(res => {
                    this.$message.success('删除成功')
                    this.getBPlanList()
                })
            },
            // 取消按钮
            cancel() {
                this.open = false
                this.reset()
            },
            // 表单重置
            reset() {
                this.form = {
                    id: null,
                    bname: null,
                    workType: null
                }
            },
            /** 提交按钮 */
            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        if (this.form.id != null) {
                            updateBPlan(this.form).then(response => {
                                this.open = false
                                this.getBPlanList()
                            })
                        } else {
                            addBPlan(this.form).then(response => {
                                this.open = false
                                this.getBPlanList()
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .head {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 280px);
    }
    .btn {
        cursor: pointer;
    }
</style>

